export class FloatLabel {

    /**
     * Get DOM elements
     *
     * @param {string} selector Container selector
     * @public
     */
    static init(selector)
    {
        const $ = jQuery;
        const inputSelector = selector + ' input, textarea, .js-datemask-html';

        // Check if input is filled
        $(inputSelector).each(function (index, field) {
            const $field = $(field);
            const $container = $field.closest(selector);
            $container.addClass('is-floating-initialized');

            if ($field.val() !== '') {
                $container.addClass('is-floating');
            }

            // Check if field val has length
            if ($field.val().length > 0) {
                $container.addClass('has-char');
            } else {
                $container.removeClass('has-char');
            }

            // Intl phone field
            FloatLabel._integrateIntlPhoneField($field)
        });

        // Type event
        $('body').on('keyup', inputSelector, function () {
            const $field = $(this);
            const $container = $field.closest(selector);

            if ($field.val().length > 0) {
                $container.addClass('has-char');
            } else {
                $container.removeClass('has-char');
            }
        });

        // Focus event
        $('body').on('focus', inputSelector, function () {
            const $field = $(this);
            const $container = $field.closest(selector);

            $container.addClass('is-focus');
            $container.addClass('is-floating');
        });

        // Blur event
        $('body').on('blur', inputSelector, function () {
            const $field = $(this);
            const $container = $field.closest(selector);

            if ($field.val().length === 0) {
                $container.removeClass('is-floating');
            }
        });

        $('body').on('focusout', inputSelector, function () {
            const $field = $(this);
            const $container = $field.closest(selector);

            $container.removeClass('is-focus');
        });

        //
    }

    /**
     * @param {jQuery} $field
     * @private
     */
    static _fillFloatLabelFromPlaceholder($field) {
        const $container = $field.closest('.moved-input-container');
        const $label = $container.find('.floating-label');

        $label.text($field.attr('placeholder'));
    }

    /**
     * Integrate intlphone field into float label
     *
     * @param $field
     * @private
     */
    static _integrateIntlPhoneField($field) {
        // Check if input is phone field
        if (!['phone', 'phone_number'].includes($field.attr('name'))) {
            return;
        }

        const $container = $field.closest('.moved-input-container');
        const $label = $container.find('.floating-label');
        const field = $field.get(0);

        $label.addClass('floating-label--phone');

        // On initialization

        // Open select
        field.addEventListener('open:countrydropdown', function() {
            $container.addClass('is-country-opened');
        })

        // Close select
        field.addEventListener('close:countrydropdown', function() {
            $container.removeClass('is-country-opened');
        })
    }
}